import { apiGet, apiGetPaginated, apiPatch, apiPost, PaginatedResult } from '../client'

export type AppointmentType = 'INITIAL_CONSULTATION' | 'CASE_REVIEW' | 'DOCUMENT_REVIEW' | 'FOLLOW_UP' | 'OTHER'
export type AppointmentStatus = 'PENDING' | 'CONFIRMED' | 'CANCELLED' | 'COMPLETED' | 'NO_SHOW'
export type StudentImmigrationTopic = 'H1B_VISA' | 'EB_VISA' | 'F1_VISA' | 'CPT' | 'OPT' | 'STEM_OPT' | 'ASYLUM_AND_REFUGEE' | 'NATURALIZATION_AND_CITIZENSHIP' | 'OTHER'

export interface AppointmentLawyerSummary {
  avatarUrl?: string | null
  firstName: string
  focusAreas?: string[]
  lastName: string
  lawFirmName?: string
  userId?: string
}

export interface AppointmentStudentSummary {
  avatarUrl?: string | null
  firstName: string
  lastName: string
  userId?: string
}

export interface BackendAppointment {
  [key: string]: unknown
  cancelReason?: string
  createdAt?: string
  durationMinutes: number
  id: string
  lawyer?: AppointmentLawyerSummary | null
  lawyerNotes?: string
  lawyerProfileId?: string
  meetingLink?: string
  notes?: string
  requestedAt: string
  status: AppointmentStatus
  student?: AppointmentStudentSummary | null
  studentId?: string
  topic?: StudentImmigrationTopic
  topicDetails?: string
  type: AppointmentType
}

export interface BookAppointmentPayload {
  durationMinutes?: number
  lawyerProfileId: string
  meetingLink?: string
  notes?: string
  requestedAt: string
  topic?: StudentImmigrationTopic
  topicDetails?: string
  type: AppointmentType
}

export interface UpdateAppointmentPayload {
  cancelReason?: string
  lawyerNotes?: string
  meetingLink?: string
  status: AppointmentStatus
}

export interface BusySlot {
  durationMinutes: number
  id: string
  requestedAt: string
  status: AppointmentStatus
  type: AppointmentType
}

export const listAppointments = (params?: { limit?: number; page?: number; status?: AppointmentStatus }): Promise<PaginatedResult<BackendAppointment[]>> =>
  apiGetPaginated<BackendAppointment[]>('/appointments', { params })

export const getAppointment = (id: string) => apiGet<BackendAppointment>(`/appointments/${id}`)

export const bookAppointment = (payload: BookAppointmentPayload) => apiPost<BackendAppointment>('/appointments', payload)

export const updateAppointment = (id: string, payload: UpdateAppointmentPayload) => apiPatch<BackendAppointment>(`/appointments/${id}`, payload)

export const getLawyerBusySlots = (lawyerProfileId: string) => apiGet<BusySlot[]>(`/appointments/lawyer/${lawyerProfileId}/slots`)
